import styled, { css } from "styled-components";

export const Container = styled.div`
  ${({ theme }) => css`
    max-width: ${theme.grid.container};
    margin: 0 auto;

    display: flex;
    flex-direction: column;
  `}
`;

export const Title = styled.h1`
  ${({ theme }) => css`
    font-size: 1.31rem;
    font-weight: 500;
    text-align: center;
    color: ${theme.colors.dark_background};
    align-self: center;
    margin-top: 1rem;
    margin-bottom: 2.5rem;

    strong {
      color: ${theme.colors.primary};
      font-weight: 600;
    }
  `}
`;

export const SubTitle = styled.h2`
  ${({ theme }) => css`
    font-size: 1rem;
    font-weight: 400;
    text-align: center;
    color: ${theme.colors.dark_background};
    align-self: center;

    strong {
      font-weight: 500;
    }
  `}
`;

export const WrapperResults = styled.div`
  margin-top: 1.5rem;

  display: flex;
  justify-content: center;
  gap: 3rem;

  @media (max-width: 1010px) {
    display: grid;
    grid-template-columns: 1fr;
    gap: 2rem;
  }
`;

export const ResultItem = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;

    h3 {
      font-weight: 500;
      font-size: 1rem;
    }

    span {
      font-weight: 600;
      font-size: 1.31rem;
      color: ${theme.colors.primary};
    }
  `}
`;

export const WrapperButtons = styled.div`
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  margin-top: 3rem;
`;

export const WrapperTerms = styled.div`
  text-align: center;
  margin-top: 3.12rem;
  margin-bottom: 2.5rem;

  p {
    font-size: 0.75rem;
    font-weight: 500;
    line-height: 1rem;
    margin-bottom: 0.5rem;
  }
`;

export const CompareText = styled.h3`
  ${({ theme }) => css`
    font-size: 1rem;
    font-weight: 500;
    color: ${theme.colors.dark_background};
    align-self: center;
    margin-bottom: 2rem;
  `}
`;
